import { Button, Col, Dropdown, Form, Input, Row, Select, Space, Spin, Switch } from 'antd';
import React, { useState, useContext, useEffect } from 'react';
import styles from './styles.module.scss';
import {
  SelectStringInput,
} from '../../../../../select-input';
import {
  IsAdminContext,
  StrengthPassionsListContext,
  UserStrengthPassionsDataContext,
  NumberOfStrengthPassionsContext,
} from '../../../../../../../context';
import axiosInstance from '../../../../../../../axios_instance';
import { useParams } from 'react-router-dom';
import { errorHandling } from '../../../../../../../utils/helper';
import styled from 'styled-components';
import { IsAnyNumberValidator } from '../../../../../../../utils/validators';
import { Option } from 'antd/es/mentions';

const AddStrengthPassions: React.FC<{ setAddNew: any }> = ({
  setAddNew,
}: {
  setAddNew: any;
}) => {
  const { userStrengthPassionsData, setUserStrengthPassionsData } = useContext(UserStrengthPassionsDataContext);
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  const [message, setMessage] = useState<string>();
  //This url query parameter will be available for admin user
  const { employeeId } = useParams();
  const { numberOfStrengthPassions, setNumberOfStrengthPassions } = useContext(NumberOfStrengthPassionsContext);

  const [showInResume, setShowInResume] = useState(true);

  const handleChangeResume = (value: any) => {
    setShowInResume(value);
  };

  const handleSave = (values: any) => {
    setIsSubmitted(true)
    values.show_in_resume = showInResume;
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/strength_passions';
      values.profile_id = employeeId;
    } else {
      url = '/api/v1/profile/strength_passions';
    }
    axiosInstance
      .post(url, values)
      .then((response) => {
        console.log(response);
        const userStrengthPassions = response.data.strength_passions.filter(
          (strengthPassion: any) =>
            strengthPassion['status']['id'] === 1
        );
        // const orderedStrengthPassions = response.data.strengthPassions.map((strengthPassionId: number) =>
        //   userStrengthPassions.find((userStrengthPassion: any) => userStrengthPassion.strengthPassion_id === strengthPassionId)
        // ).filter((item: any) => item !== undefined);
        setUserStrengthPassionsData(userStrengthPassions);
        setAddNew(false);
        setNumberOfStrengthPassions(userStrengthPassions.length);
      }
      )
      .catch((error) => {
        console.log(error);
        errorHandling(error, setErrorMessage);
      })
      .finally(() => {
        setIsSubmitted(false)
      });
  };

  return (
    <div>
      <Form onFinish={handleSave} scrollToFirstError>
        <Row gutter={24} className={styles.row}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", position: "absolute", bottom: "8px", right: "8px" }}><Switch defaultChecked onChange={handleChangeResume} /><span>Show in resume</span></div>
          <Col span={12}>
            <Row gutter={24} className={styles.row}>
              <Col span={12} className="mb-3">
                <Form.Item name="type" label="Type">
                  <Select placeholder="Select Type" optionLabelProp="label" options={[{ value: "1", label: "Strength" }, { value: "2", label: "Passion" }]} />
                </Form.Item>
              </Col>
              <Col span={24}>
                {message && <p style={{ color: "green" }}>{message}</p>}
                <Form.Item name="name" className={styles.title} labelAlign='left' label="Name" rules={[{ required: true, message: 'Please enter Strength or Passion Name' }]}>
                  <Input placeholder="Enter Strength or Passion Name" />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Form.Item name="description" label="Description">
              <Input.TextArea rows={4} placeholder="Enter Description" />
            </Form.Item>
          </Col>

        </Row>
        <Row>
          {isSubmitted ? <Spin /> : <></>}
          <Form.Item style={{ float: 'right', marginLeft: 'auto' }}>
            <Button
              className={styles['save-button']}
              type="primary"
              htmlType="submit"
              style={{ float: 'right', marginLeft: 'auto', marginRight: '0px' }}
            // disabled={
            //   !ProjectValue
            // }
            >
              Save
            </Button>
          </Form.Item>

          <Button
            className={styles['cancel-button']}
            style={{ marginRight: '0px' }}
            onClick={(e) => {
              setAddNew(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </div>
  );
};

export default AddStrengthPassions;
